import { omit } from 'ramda';
import useMutationErrorHandler from '../../errors/useMutationErrorHandler';
const useGenericMutationUseCase = (useMutation) => {
    const mutation = useMutation();
    const mutationErrorHandler = useMutationErrorHandler();
    const execute = (variables, helpers, options = {}) => mutation.mutate(variables, {
        onError: (error, _, context) => {
            mutationErrorHandler.handleError(error, helpers);
            if (options.onError)
                options.onError(error, variables, context);
        },
        onSettled: (data, error, _, context) => {
            helpers?.setSubmitting(false);
            if (options.onSettled)
                options.onSettled(data, error, variables, context);
        },
        onSuccess: (data, _, context) => {
            mutation.reset();
            if (options.onSuccess)
                options.onSuccess(data, variables, context);
        },
    });
    return { execute, ...omit(['mutate'], mutation) };
};
export default useGenericMutationUseCase;
